// event-bus.js

const orderCustomerStatus = {
    TAT_CA : -1,
    CHUA_HOAN_THANH: 0,
    HOAN_THANH: 1,
    HUY: 2,
}
const orderStatus={
    KHOI_TAO: 1,
    SAN_SANG: 2,
    CHO_XAC_NHAN: 3,
    CHO_NHAN_HANG: 4,
    DANG_VAN_CHUYEN: 5,
    HOAN_THANH: 6,
    DA_HUY: 7,
}
const locationType = {
    Destination: 1,
    Arrival: 2
}
export default {
    locationType,
    orderCustomerStatusConstant:orderCustomerStatus,
    orderStatusConstant:orderStatus,
    orderCustomerStatus: [
        {
            value: orderCustomerStatus.TAT_CA,
            text: window.__t('js.tat_ca'),
            color: '#F3A93F',
        },
        {
            value: orderCustomerStatus.CHUA_HOAN_THANH,
            text: window.__t('js.chua_hoan_thanh'),
            color: '#F3A93F',
        },

        {
            value: orderCustomerStatus.HOAN_THANH,
            text: window.__t('js.hoan_thanh'),
            color: 'green',
        },
        {
            value: orderCustomerStatus.HUY,
            text: window.__t('js.huy_34ca764c'),
            color: '#343a40',
        },
    ],
    orderStatus:[
        {
            value: orderStatus.KHOI_TAO,
            text: window.__t('js.cho_giao_cho_doi_tac_van_tai'),
            color: '#039cfd',
          },
          {
            value: orderStatus.SAN_SANG,
            text: window.__t('js.san_sang'),
            color: '#6c757d',
          },
          {
            value: orderStatus.CHO_XAC_NHAN,
            text: window.__t('js.cho_xac_nhan'),
            color: '#aa315b',
          },
          {
            value: orderStatus.CHO_NHAN_HANG,
            text: window.__t('js.cho_nhan_hang'),
            color: '#9d5508',
          },
        
          {
            value: orderStatus.DANG_VAN_CHUYEN,
            text: window.__t('js.dang_van_chuyen'),
            color: '#678bfb',
          },
          {
            value: orderStatus.HOAN_THANH,
            text: window.__t('js.hoan_thanh'),
            color: '#52bb56',
          },
          {
            value: orderStatus.DA_HUY,
            text: window.__t('js.huy_34ca764c'),
            color: '#343a40',
          },
    ],
   
    
}